import getConfig from 'next/config';
// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app';

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/analytics';

// Add the Firebase products that you want to use
import 'firebase/auth';
// import 'firebase/firestore';

// Only holds serverRuntimeConfig and publicRuntimeConfig
const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_FIREBASE_CLIENT_CONFIG } = publicRuntimeConfig;

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(NEXT_PUBLIC_FIREBASE_CLIENT_CONFIG);
}
